'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Box, Container, List, ListItem, ListItemText, Typography } from '@mui/material';

export const AgbSection = ({ data }) => {


    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom align="center">
                        {data.title}
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="lg">
                    <Box sx={{ mt: 4 }}>
                        <List>
                            {data.agbdata.map((item, index) => (
                                <ListItem key={index} sx={{ display: 'block', mb: 2 }}>
                                    <ListItemText primary={<Typography variant="h6" component="h3">{item.title}</Typography>} secondary={item.text} />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Container>
            </div>
        </motion.section>
    );
};
